const RECEIVE_ALL_OMNI_REGIONS = 'src/omniCountries/RECEIVE_ALL_OMNI_REGIONS';

export default { RECEIVE_ALL_OMNI_REGIONS };
